import { selectUserOrgByApp } from '@rsos/sinatra';
import { CLOSED } from '../../constants/issueStatuses';
import { patchIssue } from '../../services/capstone';
import {
  DELETE_ISSUE_START,
  DELETE_ISSUE_SUCCESS,
  DELETE_ISSUE_FAILED,
} from '../actionTypes';

export const deleteIssueStart = () => ({
  type: DELETE_ISSUE_START,
});

export const deleteIssueSuccess = issue => ({
  type: DELETE_ISSUE_SUCCESS,
  issue,
});

export const deleteIssueFailed = error => ({
  type: DELETE_ISSUE_FAILED,
  error,
});

/**
 * Cancels the approval process for the issue. This means the PSAP
 * has decided to cancel the process likely by re-uploading a new shapefile.
 * @param {Object} issue - The issue object
 * @param {string} issue.issue_key - The key for the issue
 */
const deleteIssue = issue => (dispatch, getState) => {
  const { sinatra } = getState();
  const application = sinatra.user.currentRole.application;
  const org = selectUserOrgByApp(sinatra, application);

  dispatch(deleteIssueStart());
  return patchIssue(issue, org.name, CLOSED)
    .then(() => dispatch(deleteIssueSuccess(issue)))
    .catch(error => {
      throw dispatch(deleteIssueFailed(error));
    });
};

export default deleteIssue;
